import {IApiService, Plans, QuestionnaireRequestParams, SignupRequestParams} from '../../../../types/src';
import {GoogleSignInRequest} from '../../components/signInForm/GoogleSignIn';

export class ClientService {
  client: IApiService;
  constructor({client}: {client: IApiService}) {
    this.client = client;
  }

  handleResponse(response: any) {
    const {data} = response;
    if (response.status !== 200) {
      if (response.status === 401) {
        return this.logout();
      }
      return Promise.reject('Bad request');
    }
    return data;
  }
  login(email: string, password: string) {
    return this.client
      .post('clients/login', {email, password, source: 'webapp'})
      .then(this.handleResponse)
      .then(({clients, status, team_member, jwt}: any) => {
        const client = clients[0];
        if (!client) {
          return Promise.reject(status);
        }
        jwt && (client.jwt = jwt);
        return {client, team_member};
      });
  }
  logout() {
    return this.client.post('clients/logout', {});
  }
  async signup(params: SignupRequestParams) {
    return this.client
      .post('clients/signup', {...params, source: 'webapp'})
      .then(this.handleResponse)
      .then(({clients, status, team_member}: any) => {
        const client = clients[0];
        if (!client) {
          return Promise.reject(status);
        }
        return {client, team_member};
      })
      .catch((response) => {
        if (response.status === 401) {
          return this.logout();
        }
        return Promise.reject(response as Error);
      });
  }
  onboardQuestionnaire(params: QuestionnaireRequestParams) {
    return this.client.post('clients/onboard-questionnaire', {...params, source: 'webapp'}).then(this.handleResponse);
  }
  updateAttribute(attributes: any) {
    return this.client
      .put('clients', {...attributes})
      .then(this.handleResponse)
      .then(({clients, status}: any) => {
        const client = clients[0];
        if (!client) {
          return Promise.reject(status);
        }
        return client;
      });
  }
  requestCampaignsInitialReview() {
    return this.client.put('clients', {method: 'submit_for_initial_review'});
  }
  getClient() {
    return this.client
      .get('clients', {})
      .then(this.handleResponse)
      .then(({clients, status, team_member}: any) => {
        const client = clients[0];
        if (!client) {
          return Promise.reject(status);
        }
        return {client, team_member};
      });
  }

  requestPasswordReset(email: string) {
    return this.client.post('clients/password_reset/generate', {email: email});
  }
  checkPasswordResetToken(token: string) {
    return this.client.post('clients/password_reset/check', {token: token});
  }
  changePassword(token: string, password: string) {
    return this.client.put('clients/password_reset/complete', {token: token, new_password: password});
  }
  updatePassword(old_password: string, new_password: string) {
    return this.client.put('api/v2/clients/change_password', {new_password, old_password});
  }
  changeClientFeatures(features: any) {
    return this.client.post('admin_maintenance/change_client_features', {...features});
  }
  notifyInstance(params: any) {
    return this.client.post('api/v2/clients/notify_instance', params);
  }
  generateApiToken() {
    return this.client.post('api/v2/clients/generate-api-key', {});
  }
  getApiToken() {
    return this.client.get('/api/v2/clients/get-api-key', {});
  }
  authorizeClient(params: any) {
    return this.client.post('oauth2/authorize', params);
  }
  googleSignIn(requestData: GoogleSignInRequest) {
    return this.client
      .post('api/v2/google-sign-in', requestData)
      .then(this.handleResponse)
      .then((data: any) => {
        return data;
      });
  }
  getPaymentIntent(planId: Plans, couponId: string | null, paymentIntentId?: string) {
    const payload = {plan_id: planId};
    if (couponId?.length) {
      payload['coupon_id'] = couponId;
    }
    if (paymentIntentId) {
      payload['payment_intent_id'] = paymentIntentId;
    }
    return this.client
      .post('clients/payment_intent', payload)
      .then(this.handleResponse)
      .then((data: any) => {
        return data;
      })
  }
}
